export const legacy = {
  name: 'onify:legacy',
  // Don't include file extension of css or sass file
  cssPath: 'css/legacy',
  vuetify: {
    defaults: {
      VTextField: {
        variant: 'solo',
      },
      VSelect: {
        variant: 'solo',
      },
      VFileInput: {
        variant: 'solo',
      },
      VTextarea: {
        variant: 'solo',
      },
      VAutocomplete: {
        variant: 'solo',
      },
      VBtn: {
        variant: 'elevated',
        size: 'large',
      },
    },
    theme: {
      dark: false,
      colors: {
        background: '#a6a5a9',
        primary: '#6391E2',
        'primary-checkbox': '#6391E2',
        error: '#BF4342',
        surface: '#FFFFFF',
        'on-surface': '#1D1B1E',
        highlight: '#FFEB3B',
      },
    },
  },
};
